import React, { useState } from 'react';
import { useEffect } from 'react';
import { auth, firestore } from '../../firebase/firebaseConfig';
import { RecaptchaVerifier, onAuthStateChanged, signInWithPhoneNumber } from 'firebase/auth';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/esm/Button';
import { onSnapshot, doc } from "firebase/firestore";

function Login ( props ) {
    let [ number, setNumber ] = useState( props.details.phone );

    useEffect( () => {
        document.title = "Laundry Buddy - Login";
        document.querySelector( ".loader-container" ).style.display = "flex";
        onAuthStateChanged( auth, ( user ) => {
            if ( user ) {
                onSnapshot( doc( firestore, "users", user.uid ), ( snapshot ) => {
                    if ( snapshot.exists() ) {
                        window.location.href = "/";
                    } else {
                        window.location.href = "/signup";
                    }
                } );
            } else {
                setTimeout( () => {
                    document.querySelector( ".loader-container" ).style.display = "none";
                }, 1000 );
            }
        } )
    }, [] )

    function numberCheck ( target, value ) {
        var reg = new RegExp( '^[0-9]+$' );
        if ( reg.test( value ) ) {
            setNumber( value );
        } else if ( value === "" ) {
            setNumber( "" );
            target.value = "";
        } else {
            target.value = number;
        }
    }

    function getRecaptchaVerifier () {
        window.recaptchaVerifier = new RecaptchaVerifier( 'recaptcha-container', {
            'size': 'invisible',
            'callback': ( response ) => {
                console.log( "Captcha Resolved" );
            }, defaultCountry: "IN"
        }, auth );
    }

    async function loginNumberSubmit ( event ) {
        event.preventDefault();
        document.querySelector( ".sending-otp-registration" ).style.display = "block";
        document.querySelector( ".register-button" ).setAttribute( "disabled", "" );
        getRecaptchaVerifier();
        const appVerifier = window.recaptchaVerifier;
        const phoneNumber = "+91" + number;

        signInWithPhoneNumber( auth, phoneNumber, appVerifier )
            .then( ( confirmationResult ) => {
                window.confirmationResult = confirmationResult;
                console.log( "SMS Sent" );
                props.settingDetails( {
                    name: props.details.name,
                    phone: number,
                    email: props.details.email,
                    address: props.details.address
                } );
                document.querySelector( ".sending-otp-registration" ).style.display = "none";
                document.querySelector( ".otp-sent-registration" ).style.display = "block";
                setTimeout( () => {
                    document.querySelector( ".otp-sent-registration" ).style.display = "none";
                    document.querySelector( ".move-to-otp-registration" ).click();
                }, 2000 )
            } ).catch( ( error ) => {
                console.log( error );
                console.log( "not Sent" );
                document.querySelector( ".sending-otp" ).style.display = "none";
                document.querySelector( ".phone_authentication_error" ).style.display = "block";
                setTimeout( () => {
                    window.location.reload();
                }, 2000 )
            } );
    }

    return (
        <div className='registration-container'>
            <div id="recaptcha-container"></div>
            <div className='registration-inner-container'>
                <div className='registration-container-content'>
                    <a className='registration-image laptop' href="https://play.google.com/store/apps/details?id=com.laundrybuddy.laundry_buddy" target="_blank" rel="noreferrer"><img src={require( "../../images/registration-image-1.webp" )} alt="" /></a>
                    <a className='registration-image mobile' href="https://play.google.com/store/apps/details?id=com.laundrybuddy.laundry_buddy" target="_blank" rel="noreferrer"><img src={require( "../../images/registration-image-mobile.webp" )} alt="" /></a>
                </div>
                <form className='registration-container-form' onSubmit={event => loginNumberSubmit( event )}>
                    <h3>Welcome Back !!!</h3>
                    <h6>Let's Check if you have an account or not...</h6>
                    <div className='form-input-container'>
                        <div className='form-input-head'>
                            Phone Number
                        </div>
                        <div className='form-input'>
                            <input type="tel" placeholder='Enter Your Phone Number' value={number} name="phone" minLength={10} maxLength={10} onChange={event => numberCheck( event.target, event.target.value )} required autoFocus />
                        </div>
                    </div>
                    <span className='sending-otp-registration message hidden'>Sending OTP ....</span>
                    <span className='otp-sent-registration message hidden'>OTP Sent ....</span>
                    <span className='phone_authentication_error-registration message-error hidden'>Too Many Attempts. Please Try Again Later.</span>
                    <Button type="submit" className='register-button'>Send OTP</Button>
                    <Link to="/otp" className="move-to-otp-registration">Move</Link>
                </form>
            </div>
        </div>
    )
}

export default Login